import { SERVICE_NAME } from '../constants';
import { isDesktopLayout } from '../constants/responsive';
import {
  SHELLS_MAP,
  LAYOUT_DIMENSIONS_BY_SHELL_MAP,
  CLASS_NAME_BY_SHELL_MAP,
  DEFAULT_LAYOUT_DIMENSIONS,
} from '../constants/shells';

export const getIsDesktop = () => window.innerWidth >= isDesktopLayout.minWidth;
export const getIsScShell = (node) =>
  node?.getAttribute?.('data-testid') === 'sc';

export const getIsMvpShell = (node) =>
  !!node &&
  !!node.getAttribute &&
  node.getAttribute('data-id') === SERVICE_NAME;

export const getShellName = (node) => {
  const isDesktop = exportFunctions.getIsDesktop();

  if (exportFunctions.getIsScShell(node)) {
    return isDesktop ? SHELLS_MAP.SC_DESKTOP_SHELL : SHELLS_MAP.SC_MOBILE_SHELL;
  }

  if (exportFunctions.getIsMvpShell(node)) {
    return isDesktop
      ? SHELLS_MAP.MVP_DESKTOP_SHELL
      : SHELLS_MAP.MVP_MOBILE_SHELL;
  }
};

export const getShellNameByContainer = (container) => {
  const DOM_NODE = document.querySelector(container);

  // common solution to determine AIR environment
  return getShellName(DOM_NODE);
};

export const getShellClassName = (shell) => {
  return CLASS_NAME_BY_SHELL_MAP[shell] || '';
};

export const getShellDefaultLayoutDimensions = (shell) => {
  return LAYOUT_DIMENSIONS_BY_SHELL_MAP[shell] || DEFAULT_LAYOUT_DIMENSIONS;
};

/**
 * Sets shell css variables for correct ui integration in different envs
 * @param {Object} dimensions - Object with top, bottom etc
 * @param {String} selector - css selector to find element in DOM
 * @param {boolean=false} isExternalNavbarEnabled - boolean flag to detect if external navbar
 * enabled
 */
export const setCSSVariablesToElement = (
  dimensions,
  selector,
  isExternalNavbarEnabled = false
) => {
  try {
    if (!dimensions) {
      return;
    }

    const { top, bottom } = dimensions;

    const DOM_NODE = document.querySelector(selector);
    if (DOM_NODE && DOM_NODE.style) {
      DOM_NODE.style.setProperty?.('--host-header-height', top);
      DOM_NODE.style.setProperty?.('--host-footer-height', bottom);
      if (isExternalNavbarEnabled) {
        // if external navbar enabled - our "service" header is hidden, so we need to
        // account this in our calculations
        DOM_NODE.style.setProperty?.('--header-height', '0px');
      }
    } else {
      /* eslint-disable no-console */
      console.error(
        'No DOM_NODE is found while setting css variables to DOM_NODE!\r\n'
      );
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.error(
      'Error occurred while setting css variables to DOM_NODE!\r\n',
      e
    );
  }
};

// for testing
// solution is taken from https://medium.com/@qjli/how-to-mock-specific-module-function-in-jest-715e39a391f4
const exportFunctions = {
  getIsDesktop,
  getIsMvpShell,
  getIsScShell,
  getShellName,
  getShellClassName,
  getShellDefaultLayoutDimensions,
  setCSSVariablesToElement,
};

export default exportFunctions;
